import { render, staticRenderFns } from "./swiperMagazineMiddle.vue?vue&type=template&id=c531fc22&"
import script from "./swiperMagazineMiddle.vue?vue&type=script&lang=js&"
export * from "./swiperMagazineMiddle.vue?vue&type=script&lang=js&"
import style0 from "./swiperMagazineMiddle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c531fc22')) {
      api.createRecord('c531fc22', component.options)
    } else {
      api.reload('c531fc22', component.options)
    }
    module.hot.accept("./swiperMagazineMiddle.vue?vue&type=template&id=c531fc22&", function () {
      api.rerender('c531fc22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/swiperMagazineMiddle/swiperMagazineMiddle.vue"
export default component.exports